import { FC, useRef, useState } from 'react';

import { DataProvider, Input, StaticDataFetcherItem, Suggest } from '@hh.ru/magritte-ui';
import { BarsOutlinedSize24 } from '@hh.ru/magritte-ui/icon';

import useTrls from 'hooks/translation/useTrls';

import { useCompositeSelectionContext } from 'components/common/CompositeSelection/contexts';
import { handleOnSelectValidator } from 'components/CpcFlexibleCreate/CpcForm/AdRegions/AdRegionsInput/utils';

import { useDispatch, useSelector } from 'store/utils';

const TrlKeys = {
    title: 'AdCreate.AdForm.Regions.Popup.title',
    notFound: 'AdCreate.AdForm.Regions.Popup.notFound',
    searchPlaceholder: 'AdCreate.AdForm.Regions.Popup.searchPlaceholderMagritte',
    reset: 'AdCreate.AdForm.Regions.Popup.reset',
};

export const AdRegionsInput: FC<{ provider: DataProvider<StaticDataFetcherItem> }> = ({ provider }) => {
    const campaignErrors = useSelector((state) => state.createCampaign.campaignErrors);
    const areasErrors = campaignErrors.areas;

    const suggestRef = useRef<HTMLDivElement>(null);
    const { setTreeSelectorModalVisibility, collection, value, excludedValue, onChange } =
        useCompositeSelectionContext();

    const trl = useTrls();
    const dispatch = useDispatch();

    const [selectedText, setSelectedText] = useState('');

    const handleOpenModal = () => {
        setTreeSelectorModalVisibility(true);
    };

    const handleChange = (inputValue: string, isValueFromList?: boolean) => {
        if (isValueFromList) {
            suggestRef.current?.blur();
            return;
        }
        setSelectedText(inputValue);
    };

    return (
        <Suggest
            ref={suggestRef}
            dataProvider={provider}
            inputValue={selectedText}
            headerTitle={trl(TrlKeys.title)}
            errorPlaceholder={trl(TrlKeys.notFound)}
            trls={{
                resetButton: trl(TrlKeys.reset),
            }}
            onChange={handleChange}
            onSelectValidator={(inputValue) =>
                handleOnSelectValidator(collection, inputValue, value, excludedValue, onChange, dispatch)
            }
            input={{
                component: Input,
                props: {
                    size: 'medium',
                    placeholder: trl(TrlKeys.searchPlaceholder),
                    buttonIcon: BarsOutlinedSize24,
                    onButtonClick: handleOpenModal,
                    invalid: Boolean(areasErrors),
                    errorMessage: areasErrors,
                    'data-qa': 'region-targeting-input',
                },
            }}
        />
    );
};
